import config from '../Config'
import { api } from '../Services/api'
import { track } from './analytics'

export function storyUrl(storyId) {
  return `${config.SITE_URL}/prica/${storyId}`
}

/* Back on this tab after an article (article_return, analytics spec 5.2). */
let away = null
document.addEventListener('visibilitychange', () => {
  if (!away) return
  if (document.visibilityState === 'hidden') away.left = true
  else if (away.left) {
    track('article_return', {
      ...away.props,
      time_away_sec: Math.round((Date.now() - away.at) / 1000),
    })
    away = null
  }
})

/* Outbound click to the portal's article (the link itself opens it in a new
   tab): counts a read for "Najčitanije" and logs article_outbound_click, the
   plan's main event. `article`: one of the story's other sources ("Drugi
   pišu"); entry: card | main_story | others | search | quick_results | read_also. */
export function articleOpened({
  story,
  article = null,
  entry,
  position = null,
  isNew = false,
  surface = null,
}) {
  api.articleOpened(article ? article.id : story.articleId)
  const props = {
    story_id: story?.id ?? null,
    source_slug: (article || story)?.source?.slug ?? null,
    surface,
  }
  track('article_outbound_click', {
    ...props,
    entry,
    position,
    source_count: story?.sourceCount ?? null,
    topic_slug: story?.topic?.slug ?? null,
    is_developing: Boolean(story?.isDeveloping),
    is_new: Boolean(isNew),
  })
  away = { props, at: Date.now(), left: false }
}
